import { Injectable, signal } from '@angular/core';
import { SourceTrackingTypes } from '@uc/web/shared/data-models';
import { ModalService } from '@uc/shared/ui';
import { ClearingVisitWebsiteModalComponent } from '../clearing-visit-website-modal/clearing-visit-website-modal.component';

@Injectable({ providedIn: 'root' })
export class ClearingVisitWebsiteModalService {
	uniId = signal<number | null>(null);
	uniName = signal<string>('');
	privacyPolicyUrl = signal<string>('');
	externalLink = signal<string>('');
	componentName = signal<string>('');
	cleSearchOrderPosition = signal<number | null>(null);
	source = signal<string>('');
	sourceType = signal<SourceTrackingTypes>('');
	trackingEnabled = signal<boolean>(true);

	constructor(private _modalSrv: ModalService) {}

	reset() {
		this.uniId.set(null);
		this.uniName.set('');
		this.privacyPolicyUrl.set('');
		this.externalLink.set('');
		this.componentName.set('');
		this.cleSearchOrderPosition.set(null);
		this.source.set('');
		this.sourceType.set('');
		this.trackingEnabled.set(true);
	}

	setDataAndOpenModal(
		externalUrl: string,
		uniName: string,
		uniId: number,
		source: string,
		sourceType: SourceTrackingTypes,
		cleSearchOrderPosition: number,
		componentName: string,
		privacyPolicyUrl: string,
		trackingEnabled = true,
	) {
		this.externalLink.set(externalUrl);
		this.uniName.set(uniName);
		this.uniId.set(uniId);
		this.source.set(source);
		this.sourceType.set(sourceType);
		this.cleSearchOrderPosition.set(cleSearchOrderPosition);
		this.componentName.set(componentName);
		this.privacyPolicyUrl.set(privacyPolicyUrl);
		this.trackingEnabled.set(trackingEnabled);

		this._modalSrv.setContent(ClearingVisitWebsiteModalComponent);
		this._modalSrv.show();
	}
}
